module.exports = __webpack_public_path__ + "static/img/加入采购单@3x.73f9cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/加入采购单@3x.png
// module id = ajpU
// module chunks = 192